<template>
    <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{{ tooltipText }}</title>
        <path
            d="M7.08358 14.3487C10.9747 7.44955 12.9203 4 16.0013 4C19.0822 4 21.0278 7.44955 24.919 14.3487L25.4038 15.2084C28.6374 20.9415 30.2542 23.808 28.7929 25.904C27.3317 28 23.7165 28 16.4862 28H15.5164C8.28605 28 4.67086 28 3.20965 25.904C1.74842 23.808 3.36518 20.9415 6.5987 15.2084L7.08358 14.3487Z"
            :class="strokeClass" stroke="#FFAF4B" stroke-opacity="0.984314" stroke-width="3.75" />
        <path
d="M16 10.666V17.3327" :class="strokeClass" stroke="#FFAF4B" stroke-opacity="0.984314" stroke-width="3.75"
            stroke-linecap="round" />
        <path
            d="M16.0013 22.6667C16.7377 22.6667 17.3346 22.0697 17.3346 21.3333C17.3346 20.597 16.7377 20 16.0013 20C15.2649 20 14.668 20.597 14.668 21.3333C14.668 22.0697 15.2649 22.6667 16.0013 22.6667Z"
            fill="#FFAF4B" :class="strokeClass" fill-opacity="0.984314" />
    </svg>
</template>

<script setup lang="ts">
defineProps<{
    size?: string,
    strokeClass?: string,
    tooltipText?: string,
}>()
</script>